import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';

import s from './FadeIn.sss';

// types
type FadeInProps = Omit<CSSTransitionProps, 'in' | 'timeout'> & {
  in?: boolean;
  timeout?: CSSTransitionProps['timeout'];
  className?: string;
};

export const FadeIn: React.FC<FadeInProps> = (props) => {
  const ref = useRef(null);

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={300}
      classNames={{
        appear: s.appear,
        appearActive: s.appearActive,
        enter: s.enter,
        enterActive: s.enterActive,
        enterDone: s.enterDone,
      }}
      {...props}
      nodeRef={ref}
    >
      <div
        ref={ref}
        className={props.className}
      >
        {props.children}
      </div>
    </CSSTransition>
  );
};
